import { render, staticRenderFns } from "./ReportsHelp.vue?vue&type=template&id=746a50e2"
import script from "./ReportsHelp.vue?vue&type=script&lang=js"
export * from "./ReportsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports